module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}



//////////////////
// WEBPACK FOOTER
// ./~/_public-encrypt@4.0.3@public-encrypt/xor.js
// module id = 321
// module chunks = 0